const firebaseConfig = {
  apiKey: "AIzaSyDmljwwdKXni1PmsDcyjgEbfVOhhoudmpA",
  authDomain: "creative-agency-4a56c.firebaseapp.com",
  databaseURL: "https://creative-agency-4a56c.firebaseio.com",
  projectId: "creative-agency-4a56c",
  storageBucket: "creative-agency-4a56c.appspot.com",
  messagingSenderId: "719817150723",
  appId: "1:719817150723:web:ed10f5f0fea70700d81936"
};
 export default firebaseConfig ;